import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { normalizedTrackingStatus, Text } from '@reveni-io/reveni-ui'

import TimelineEvent from '../TimelineEvent/TimelineEvent'
import * as Styles from './styles'

const TimelineDateGroup = ({ label, events }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="allCapsL" color={theme.colors.grey.tone600}>
        {label}
      </Text>
      <Styles.EventList>
        {events?.map((event, index) => (
          <TimelineEvent
            key={index}
            time={event?.time}
            label={t(normalizedTrackingStatus[event?.substatus])}
            isAlert={event?.is_alert}
          />
        ))}
      </Styles.EventList>
    </Styles.Container>
  )
}

export default TimelineDateGroup
